import { render, staticRenderFns } from "./edit2.vue?vue&type=template&id=57469e02&scoped=true"
import script from "./edit2.vue?vue&type=script&lang=js"
export * from "./edit2.vue?vue&type=script&lang=js"
import style0 from "./edit2.vue?vue&type=style&index=0&id=57469e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57469e02",
  null
  
)

export default component.exports